let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("hPxUI")]).then(() => parcelRequire('jOclj'));